import type { Translations } from './translation';

const translations: Translations = {
	ticket: 'Billet',
	ticketOptions: 'Options de billet',
	includedInTicket: 'Inclus dans le billet',
	journeyDetails: 'Détails du voyage',
	refreshItinerary: 'Actualiser le voyage',
	walk: 'À pied',
	bike: 'Vélo',
	cargoBike: 'Vélo Cargo',
	scooterStanding: 'Trottinette',
	scooterSeated: 'Trottinette avec siège',
	car: 'Voiture',
	taxi: 'Taxi',
	moped: 'Cyclomoteur',
	unknownVehicleType: 'Type de véhicule inconnu',
	electricAssist: 'Assistance électrique',
	electric: 'Électrique',
	combustion: 'Combustion',
	combustionDiesel: 'Diesel',
	hybrid: 'Hybride',
	plugInHybrid: 'Hybride rechargeable',
	hydrogenFuelCell: 'Pile à combustible hydrogène',
	from: 'De',
	to: 'À',
	myLocation: 'Ma position',
	reverseDirections: 'Inverser le sens',
	viaStop: 'Arrêt intermédiaire',
	viaStops: 'Arrêts intermédiaires',
	addViaStop: 'Ajouter un arrêt intermédiaire',
	removeViaStop: "Supprimer l'arrêt intermédiaire",
	viaStayDuration: 'Temps de correspondance minimum',
	position: 'Position',
	arrival: 'Arrivée',
	departure: 'Départ',
	duration: 'Durée',
	arrivals: 'Arrivées',
	later: 'plus tard',
	earlier: 'plus tôt',
	departures: 'Départs',
	connections: 'Itinéraires',
	switchToArrivals: 'Afficher les arrivées',
	switchToDepartures: 'Afficher les départs',
	track: 'Voie',
	platform: 'Quai',
	trackAbr: 'V.',
	platformAbr: 'Q.',
	arrivalOnTrack: 'Arrivée sur la voie',
	tripIntermediateStops: (n: number) => {
		switch (n) {
			case 0:
				return 'Aucun arrêt intermédiaire';
			case 1:
				return '1 arrêt intermédiaire';
			default:
				return `${n} arrêts intermédiaires`;
		}
	},
	sharingProvider: 'Opérateur',
	sharingProviders: 'Opérateurs',
	none: 'Aucun',
	transfers: 'correspondances',
	returnOnlyAtStations: 'Le véhicule doit être rendu à une station.',
	roundtripStationReturnConstraint: 'Le véhicule doit être rendu à la station de départ.',
	rentalStation: 'Station',
	rentalGeofencingZone: 'Zone',
	noItinerariesFound: 'Aucun itinéraire trouvé.',
	advancedSearchOptions: 'Options',
	selectTransitModes: 'Sélectionner les modes de transport en commun',
	defaultSelectedModes: 'Tous les transports en commun',
	defaultSelectedProviders: 'Tous les opérateurs',
	selectElevationCosts: 'Éviter les pentes',
	wheelchair: 'Correspondances accessibles uniquement',
	hgvRoutingOptions: 'Options poids lourd',
	vehicleHeight: 'Hauteur du véhicule (m)',
	vehicleWidth: 'Largeur du véhicule (m)',
	vehicleLength: 'Longueur du véhicule (m)',
	vehicleWeight: 'Poids du véhicule (t)',
	vehicleTopSpeed: 'Vitesse max. (km/h)',
	vehicleAxleCount: 'Nombre d’essieux',
	vehicleAxleLoad: 'Charge par essieu (t)',
	vehicleHazmat: 'Matières dangereuses',
	vehicleHazmatWater: 'Dangereux pour l’eau',
	vehicleTrailer: 'Avec remorque',
	vehicleLezAccess: 'Accès aux zones à faibles émissions',
	useRoutedTransfers: 'Utiliser les correspondances routées',
	bikeRental: 'Utiliser véhicules partagés',
	requireBikeTransport: 'Emport vélo',
	requireCarTransport: 'Emport voiture',
	noCompulsoryReservation: 'Sans réservation obligatoire',
	considerRentalReturnConstraints: 'Retourner les véhicules partagés pendant le voyage',
	default: 'Sauvegarder les paramètres',
	timetableSources: 'Sources des horaires',
	tripCancelled: 'Trajet annulé',
	stopCancelled: 'Arrêt supprimé',
	addStop: 'Ajouter un arrêt',
	inOutDisallowed: 'Montée/descente interdite',
	inDisallowed: 'Montée interdite',
	outDisallowed: 'Descente interdite',
	unscheduledTrip: 'Trajet supplémentaire',
	alertsAvailable: 'Annonces disponibles',
	dataExpiredSince: 'Attention : Données expirées, valides jusqu’au',
	FLEX: 'Transport à la demande',
	WALK: 'À pied',
	BIKE: 'Vélo',
	RENTAL: 'Location',
	RIDE_SHARING: 'Covoiturage',
	CAR: 'Voiture',
	HGV: 'Poids lourd',
	CAR_PARKING: 'Parking Relais (P+R)',
	CAR_DROPOFF: 'Dépose (voiture)',
	TRANSIT: 'Transports en commun',
	TRAM: 'Tram',
	SUBWAY: 'Métro',
	FERRY: 'Ferry',
	AIRPLANE: 'Avion',
	SUBURBAN: 'RER',
	BUS: 'Bus',
	COACH: 'Autocar',
	RAIL: 'Train',
	HIGHSPEED_RAIL: 'Train à grande vitesse',
	LONG_DISTANCE: 'Train intercité',
	NIGHT_RAIL: 'Train de nuit',
	REGIONAL_FAST_RAIL: 'Train express',
	ODM: 'Transport à la demande',
	REGIONAL_RAIL: 'Train régional',
	OTHER: 'Autres',
	routingSegments: {
		maxTransfers: 'Correspondances max.',
		maxTravelTime: 'Temps de trajet max.',
		firstMile: 'Premier kilomètre',
		lastMile: 'Dernier kilomètre',
		direct: 'Trajet direct',
		maxPreTransitTime: 'Durée max. avant transports en commun',
		maxPostTransitTime: 'Durée max. après transports en commun',
		maxDirectTime: 'Durée max. directe',
		additionalTransferTime: 'Durée de correspondance supplémentaire',
		pedestrianSpeed: 'Vitesse piéton',
		cyclingSpeed: 'Vitesse vélo',
		transferTimeFactor: 'Pondération du temps de correspondance'
	},
	elevationCosts: {
		NONE: 'Pas de détour',
		LOW: 'Petits détours',
		HIGH: 'Grands détours'
	},
	isochronesOpacity: 'Opacité des isochrones',
	isochrones: {
		title: 'Isochrones',
		styling: 'Style de l’isochrone',
		noData: 'Pas de données',
		requestFailed: 'La requête a échoué'
	},
	alerts: {
		validFrom: 'Valable du',
		until: 'au',
		information: 'Informations',
		more: 'de plus'
	},
	RENTAL_BICYCLE: 'Vélo en libre-service',
	RENTAL_CARGO_BICYCLE: 'Vélo cargo en libre-service',
	RENTAL_CAR: 'Autopartage',
	RENTAL_MOPED: 'Cyclomoteur en libre-service',
	RENTAL_SCOOTER_STANDING: 'Trottinette debout en libre-service',
	RENTAL_SCOOTER_SEATED: 'Trottinette assise en libre-service',
	RENTAL_OTHER: 'Autre véhicule en libre-service',
	incline: 'Pente',
	CABLE_CAR: 'Téléphérique',
	FUNICULAR: 'Funiculaire',
	AERIAL_LIFT: 'Remontée mécanique',
	toll: 'Attention ! Route à péages.',
	bikesAllowed: 'Vélos autorisés',
	wheelchairAccessible: 'Accessible en fauteuil roulant',
	compulsoryReservation: 'Réservation obligatoire',
	accessRestriction: 'Accès restreint',
	continuesAs: 'Continue comme',
	earlierAlternatives: 'Alternatives plus tôt',
	laterAlternatives: 'Alternatives plus tard',
	differentStops: 'Arrêts différents',
	rent: 'Louer',
	copyToClipboard: 'Copier dans le presse-papiers',
	rideThroughAllowed: 'Passage autorisé',
	rideThroughNotAllowed: 'Passage non autorisé',
	rideEndAllowed: 'Stationnement autorisé',
	rideEndNotAllowed: 'Stationnement uniquement aux stations',
	DEBUG_BUS_ROUTE: 'Itinéraire de bus (Debug)',
	DEBUG_RAILWAY_ROUTE: 'Itinéraire ferroviaire (Debug)',
	DEBUG_FERRY_ROUTE: 'Itinéraire de ferry (Debug)',
	colorMode: {
		none: 'Pas d’affichage sur la carte',
		stops: 'Stations',
		rt: 'Horaires : retards',
		route: 'Horaires : couleurs des lignes',
		mode: 'Horaires : modes de transport'
	},
	resetToNorth: 'Réinitialiser vers le nord',
	showMyLocation: 'Afficher ma position',
	toggleHillshades: 'Afficher / masquer le dénivelé',
	routes: (n: number) => {
		switch (n) {
			case 0:
				return 'Aucun itinéraire';
			case 1:
				return '1 itinéraire';
			default:
				return `${n} itinéraires`;
		}
	},
	pageTitle: {
		default: 'MOTIS',
		fromTo: (from, to) => `${from} à ${to}`,
		departuresAt: (stop) => `Départs à ${stop}`,
		arrivalsAt: (stop) => `Arrivées à ${stop}`,
		isochronesFrom: (place) => `Isochrones depuis ${place}`
	},
	tickets: 'Billets',
	routeInformation: "Plus d'informations"
};

export default translations;
